export default function setBasketReceivers({ state }) {
  const { email, group } = state.get('app.user')
  if (!group.shared) {
    state.set('basket.receivers.tags', {
      '0': { label: email, value: email, selected: true }
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/App/actions/setBasketReceivers.js